(function($) {
  'use strict';

	$(window).scroll( () => {
		const scrolled = $(window).scrollTop();

		if( scrolled > 900 ) {
			$(".back-to-top").addClass('visible');
		} else {
			$(".back-to-top").removeClass('visible');
		}
	});

	$(".back-to-top").on('click', (e) => {
		e.preventDefault();

    $("html, body").animate({
      scrollTop: $("[id=top]").offset().top
    }, 500, 'easeInOutExpo');

		$("[id=main-content]").attr('tabindex', 0);
		$("[id=main-content]").focus();
	});

})(jQuery);
